import { Component, OnInit } from '@angular/core';

/**
 * Service file import
 */
import { SearchEventService } from "../../../services/search/searchEvent/search-event.service";

declare var $

@Component({
  selector: 'app-generate-receipts',
  templateUrl: './generate-receipts.component.html',
  styleUrls: ['./generate-receipts.component.less']
})
export class GenerateReceiptsComponent implements OnInit {

  public submitLoading: Boolean = false
  /**
   * Loader Variable Deceleration
   */
  public selectEventSkeleton: Boolean = true

  /**
   * view Variable Deceleration
   */
  public eventList: any
  public eventID: any

  public printReceipts: Boolean = false

  constructor(
    private SearchEventService: SearchEventService,
  ) { }

  async ngOnInit() {
    await this.getEventLists()
    setTimeout(() => {
      this.selectEventSkeleton = false
    }, 95)
    setTimeout(function () {
      $(`.event`).selectpicker('refresh');
    }, 100)
  }

  async generateReceipt(value) {
    this.eventID = value
    this.printReceipts = true
    this.submitLoading = true
    // setTimeout(() => {
    //   window.print()
    //   // this.submitLoading = false
    // }, 1000)

  }

  async reInitContentComp() {
    this.printReceipts = false
  }

  async getEventLists() {
    let event = await this.SearchEventService.getEventList()
    this.eventList = event.data
  }

  async outToParent(e) {
    if (e == 'emit') {
      window.print()
      this.submitLoading = false 
    }
  }

}
